/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StatusInfo } from './statusInfo';
import { PurchaseHistoryOrderOffer } from './purchaseHistoryOrderOffer';
import { PurchaseHistoryOrderPaymentMethod } from './purchaseHistoryOrderPaymentMethod';
import { PromocodeNullable } from './promocodeNullable';


export interface PurchaseHistoryOrder { 
    id?: string;
    created_at?: string;
    status?: StatusInfo;
    offer?: PurchaseHistoryOrderOffer;
    payment_method?: PurchaseHistoryOrderPaymentMethod;
    promocode?: PromocodeNullable | null;
}

